import { Lookup } from './lookup.model';
import { Country } from './country.model';
import { CountryCity } from './countryCity.model';
import { Region } from './region.model';
import { Industry } from './industry.model';
import { Currency } from './currency.model';
import { UserStudy } from './userStudy.model';
import { StudySearchStrategy } from './searchStrategy.model';
import { StudyBenchmarkRegionCountry } from './studyBenchmarkRegionCountry';
import { StudyTestedPartyRegionCountry } from './studyTestedPartyRegionCountry';
import { InterQuartileValue } from './interquartileValue.model';
import { FunctionType } from '@models/functionType.model';

export class Study {
  public studyId: number;
  public studyCode: string;
  public clientName: string;
  public studyName: string;
  public studySummary: string;
  public projectOfficeCountryId?: number;
  public projectOfficeCityId?: number;
  public startDate: any;
  public endDate?: any;
  public periodOfStudyFrom?: number;
  public periodOfStudyTo?: number;
  public fiscalYear?: number;
  public isStudyConfidential: boolean;
  public isStudyLocked: boolean;
  public isStudyDatabaseLocked: boolean;
  public currencyId?: number;
  public currencyUnitId?: number;
  public useFunctionalCurrency: boolean;
  public testedPartyName: string;
  public industryId?: number;
  public functionId?: number;
  public statusId?: number;
  public businessDescription: string;
  public industryOther: string;
  public financialResultFormatId?: number;
  public studySettingId?: number;
  public fyAlignmentMethodID: number;
  public testedPartyFiscalYearEnd: any;
  public monthsBack: number;
  public itemsPerPage = 10;
  public defaultBasePLIVendorAccountId: number;
  public translateNativeLanguageTD: boolean;
  public isAISuggestionsEnabled: boolean;
  public isDemoStudy?: boolean;
  public studyTypeId: number;
  public leveragedStudyId?: number;

  public searchStrategies: StudySearchStrategy[];

  // Lookups populated based on corresponding lookupId, should typically be returned populated from service layer
  // statusId
  public status?: Lookup;
  // currencyUnitId
  public currencyUnit?: Lookup;
  // projectOfficeCountryId
  public projectOfficeCountry?: Country;
  // projectOfficeCityId
  public projectOfficeCity?: CountryCity;
  // testedPartyRegionId
  public testedPartyRegion?: Region;
  // testedPartyCountryId
  public testedPartyCountry?: Country;
  // industryId
  public testedPartyIndustry?: Industry;
  // currencyId
  public currency?: Currency;

  // Middle-tier manages this
  public fiscalYearText?: string;

  public lockedAdminUser = '';

  public otherIndustryId: number;

  userStudies: UserStudy[];

  benchmarkCountries: StudyBenchmarkRegionCountry[] = [];

  testedPartyCountries: StudyTestedPartyRegionCountry[] = [];

  isStudyReadOnly = false;
  isStudyEditableByUser: boolean; // true if user is study member
  hasLockAccess: boolean; // true if user is Super User
  isStudyHiddenForUser: boolean; // isStudyConfidential == true and current user not a member
  max = '0';
  uq = '0';
  med = '0';
  lq = '0';
  min = '0';
  vendorName = '';
  // defaultRatioId: number;
  // ratioIds: number [] = [];
  iqrValues: InterQuartileValue[] = [];
  averagingMethodID: number;

  // Fields are declared just for ui, it is not mapped with study model
  displayStartDate: Date;
  displayEndDate: Date;
  displaytestedPartyFiscalYearEnd: Date;

  function: FunctionType;
  updatedOn: Date;
  engagementId: string;
  engagementClientChannelName: string;
  engagementStatusCode: string;
  engagementClientId: string;
  engagementOpportunityId: string;
  engagementSubServiceLine: string;
}
